<template>
  <div class="Preview-container">
    <div>
      <div class="video-container" :class="isPlay ? '' : 'bg'">
        <video :id="client.id" autoplay style="height: 100%;width: 100%" />
      </div>
    </div>
    <div class="console-container">
      <div style="max-width: 130px;display: flex;align-items: center">
        <i v-if="client.isMy" class="el-icon-s-custom" style="color:#ffffff;margin-right: .05rem" />
        <i v-if="!client.isMy" class="el-icon-s-custom" style="color:#ffffff;margin-right: .05rem" />
        <span v-if="client.isMy" style="color:#fff;font-size: .16rem;">{{ client.name }}</span>
        <span v-if="!client.isMy" style="color:#fff;font-size: .16rem;">{{ client.name }}</span>
      </div>
      <div>
        <img src="./full.png"
             v-show="!client.muted"
             class="full-screen"
             @click="fullScreenEvent(client.stream,client.id)">

<!--        <i-->
<!--          v-show="!client.muted"-->
<!--          class="el-icon-full-screen"-->
<!--          @click="fullScreenEvent(client.stream)"-->
<!--          style="color:#ffffff"-->
<!--        />-->
        <!--<i v-show="client.muted" class="el-icon-turn-off-microphone"  /> -->
        <i
          v-show="client.muted & !disableVoice"
          class="el-icon-microphone"
          @click="_openVoice()"
          style="color:#ffffff"
        />
        <i
          v-show="disableVoice"
          class="el-icon-turn-off-microphone"
          @click="_openVoice()"
          style="color:#ffffff"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      disableVoice: false,
      isPlay: false
    };
  },
  name: "Preview",
  props: {
    client: {
      type: Object,
      default: null
    }
  },
  methods: {
    _openVoice() {
      this.disableVoice = !this.disableVoice;
      if (this.disableVoice) {
        this.client.rtc.closeMicrophone();
      } else {
        this.client.rtc.openMicrophone();
      }
    },
    fullScreenEvent(stream,id) {
      this.$emit("fullScreenEvent", stream,id);
    }
  }
};
</script>

<style lang="less" scoped>
.Preview-container {
  display: inline-block;
  width: 2.5rem;
  //height: 200px;
  margin: 0 0.08rem 0.08rem 0;
  background: #212741;
  //margin-top: 2px;
}
.video-container {
  height: 1.8rem;
  width: 99%;
  margin: 0.06rem auto;
  background: transparent;

  /*-webkit-mask-image: url("~@/assets/svg/people.svg");*/
  /*mask-image: url("~@/assets/svg/people.svg");*/
  /*mask-repeat: no-repeat;*/
  /*mask-position: center;*/
  text-align: center;
}
.console-container {
  height: 0.4rem;
  background-color: #3e4a80;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0.1rem;
}
.console-container i {
  font-size: 0.22rem;
}
.console-container .svg-icon {
  font-size: 0.22rem;
}
.clientStatus {
  font-size: 1.5rem;
  line-height: 1.8rem;
}
.bg {
  background: url("./bg2.png") no-repeat center;

  background-size: 40%;
}
.full-screen{
  width:  0.22rem;
  height: 0.22rem;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute1/expertGuidance/Preview.vue